// getting language when in preview mode in new tab
export const getCurrentLangInPreviewMode = () => {
  let path = ''
  let tmp = []

  window.location.search
    .substr(1)
    .split('&')
    .forEach((item) => {
      tmp = item.split('=')
      if (tmp[0] === 'path') {
        path = decodeURIComponent(tmp[1])
      }
    })

  const lang = path.split('/')
  return lang[0] || process.env.GATSBY_DEFAULT_LANGUAGE?.toLowerCase()
}

export const getCurrentLang = (location: Location): LangCode => {
  const path = location?.pathname.split('/')
  if (!path) return getCurrentLangInPreviewMode() as LangCode

  if (path.length > 1 && path[1].length === 2) return path[1] as LangCode
  return process.env.GATSBY_DEFAULT_LANGUAGE?.toLowerCase() as LangCode
}
